import React from 'react';
import classNames from 'classnames';

import _LeftTopBox from './_LeftTopBox';
import _Map from './_Map';
import _BarBox1 from './_BarBox1';
import _BarBox2 from './_BarBox2';
import _TopPanelBox from './_TopPanelBox';
import _CardBox1 from './_CardBox1';
import _CardBox2 from './_CardBox2';
import _CardBox3 from './_CardBox3';
import _CardBox4 from './_CardBox4';

import defaultLogo from './images/logo.png';


import styles from './styles.css';
import NHFetch from '../../utils/NHFetch.js';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const speed = 6 * 1000; //轮询时间间隔（毫秒）
const errMaxCount = 3; // 请求异常最大次数

export default class Home extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            rem: 100,
            errCount: 0, //连续请求错误次数
            schoolData: {}, //学校、迎新年度数据
            mapData: {},//地图数据
        }

        this.polling;
    }

    componentDidMount() {

        // 表示1920的设计图,使用100PX的默认值
        const whdef = 100 / 1920;
        // 当前窗口的宽度
        const wW = window.innerWidth;
        // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
        const rem = parseInt(wW * whdef);

        this.setState({ rem });
        document.documentElement.style.fontSize = rem + 'px';

        /** ================== 下面开始请求数据 ================== */

        //获取学校、当前迎新年度信息
        this.getData();
    }

    componentWillUnmount() {
        document.documentElement.style.fontSize = null;

        if (this.polling) {
            clearTimeout(this.polling);
        }
    }

    getData = () => {

        //获取学校、当前迎新年度信息
        NHFetch(yxxtBasicUrl + '/sstj/getUniversityAndCurrentYearInfo', 'GET')
            .then(res => {
                if (res && res.data) {
                    this.setState({ errCount: 0, schoolData: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    clearTimeout(this.polling);
                }
            });

        //获取地图信息
        NHFetch(yxxtBasicUrl + '/sstj/getMapInfo', 'GET')
            .then(res => {
                if (res && res.data) {
                    this.setState({ errCount: 0, mapData: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    clearTimeout(this.polling);
                }
            });
    }

    render() {
        const { rem, schoolData = {}, mapData ={} } = this.state;
        return (
            <div className={styles.show_box}>
                <div className={styles.logo}>
                    <img style={{ maxWidth: 40, maxHeight: 40 }} src={'api/zhxg-xtgl/schoolMng/downloadSchoolPictureByType?type=logo'} onError={(e) => { e.target.src = defaultLogo; }} />
                    <span>{schoolData.xxmc}{schoolData.dqnd}年迎新实时数据展示</span>
                </div>
                <div className={styles.box_1}>
                    <div className={styles.box_bg}>
                        <_LeftTopBox rem={rem} />
                    </div>
                    <div className={styles.box_line} />
                    <div className={classNames(styles.box_bg, styles.box_bg_1)}>
                        <_BarBox2 rem={rem} />
                    </div>
                </div>
                <div className={styles.box_2}>
                    <div className={styles.box_bg_line} />
                    <div className={styles.box_2_top}>
                        <_TopPanelBox rem={rem} />
                        <div className={styles.box_2_top_r}>
                            <_Map rem={rem} schoolLocation={schoolData.xzqh} mapProvince={mapData.province}/>
                        </div>
                    </div>
                    <div className={styles.box_2_middle}>
                        <div className={styles.middle_l}>
                            <div style={{marginBottom: 0}} className={styles.title}>培养层次报到统计</div>
                            <_CardBox1 rem={rem} />
                        </div>
                        <div className={styles.middle_r}>
                            <div className={styles.title}>实时之最展示</div>
                            <_CardBox2 rem={rem} />
                        </div>
                    </div>
                    <div className={styles.box_line} />
                    <div className={styles.box_2_bottom}>
                        <div className={styles.bottom_l}>
                            <div className={styles.title}>学院女生比例 Top 5</div>
                            <_CardBox3 rem={rem} />
                        </div>
                        <div className={styles.bottom_r}>
                            <div className={styles.title}>学院报到率 Top 5</div>
                            <_CardBox4 rem={rem} />
                        </div>
                    </div>
                </div>
                <div className={styles.box_3}>
                    <_BarBox1 rem={rem} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./containers/Show-zzsd/index.js